import React from "react" ;
import AppBodyNotificationDropdown from "root/Wieldy/ApplicationModules/Common/Body/AppBodyNotificationDropdown";

const OrgDashAppBodyHeader= (props) =>
{
    return (
        <div className="dt-module__header d-none d-md-flex">

            {/*<AppBodyNotificationDropdown />*/}

        </div>
    ) ;
}

export default OrgDashAppBodyHeader;
